export default "__VITE_ASSET__8d9a9895__"